export default class Usuario {
  constructor(nome = '', email = '', senha = '', cpf_cnpj = '', tipo = 'usuario', tags  = []) {
    this.nome = nome;
    this.email = email;
    this.senha = senha;
    this.cpf_cnpj = cpf_cnpj;
    this.tipo = tipo;
    this.tags = tags;
  }
}